import React, { Component } from "react";
import { connect } from 'react-redux';
import { actionCreators } from '../actions/users';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import '../styles/Settings.css';

class Settings extends Component {
 
  state = { email: false, sms:false, phoneError:'', phoneValue:'' };

  constructor(props){
    super(props);
    const userNotifications = this.props.requestCurrentUserNotifications();
    userNotifications.then((u) => {
      this.setState({ email: u.emailNotification });
      this.setState({ sms: u.smsNotification });
      if(u.phone != null)
        this.setState({ phoneValue: u.phone });
      else
        this.setState({ phoneValue: '+44' });
    });
  }
  
  
  handleEmailChange = (event, props) => {
    const change = event.target.checked;
    props.currentUser.emailNotification = change;
    this.setState({ email: props.currentUser.emailNotification });
    this.props.editCurrentUserNotifications(props.currentUser);
  };

  handleSMSChange =  (event, props) => {
    if(this.validatePhoneNumber(this.state.phoneValue)){
      const change = event.target.checked;
      props.currentUser.smsNotification = change;
      this.setState({ sms: props.currentUser.smsNotification });
      props.currentUser.phone = this.state.phoneValue;
      this.props.editCurrentUserNotifications(props.currentUser);
      this.setState({ phoneError: '' });
    }else{
      this.setState({ sms: false });
      event.target.checked = false;
    }
  };

  onChangePhone = (e) => {
    this.setState({ phoneValue: e.target.value });
  }

  validatePhoneNumber = (phone) => {
    phone = phone.replace(/\s/g,'');
    var regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    if (regex.test(phone)) {
        return true;
    } else {
        this.setState({ phoneError: "Please enter a valid number." });
        return false;
    }
  }

  render() {
    return (
      <div>
        <h1 className="SettingsH1">Notifications Settings</h1>
        <table className="notificationTable">
          <tbody>
          <tr>
            <td className="SettingsTD"><p>Email Notifications</p></td>
            <td className="SettingsTD"><NotificationSwitch checked={this.state.email} onChange={(event) => this.handleEmailChange(event, this.props)} value="email"/></td>
          </tr>
          <tr>
            <td className="SettingsTD"><p>SMS Notifications</p></td>
            <td className="SettingsTD"><NotificationSwitch checked={this.state.sms} onChange={(event) => this.handleSMSChange(event, this.props)} value="sms"/></td>
          </tr>
          <tr>
            <td className="SettingsTD">
          <TextField
              error = {this.state.phoneError ? true : false}
              id="phoneField"
              disabled= {this.state.sms}
              label="Phone Number "
              value={this.state.phoneValue}
              margin="normal"
              helperText="*Required to activate SMS Notifications"
              onChange = {this.onChangePhone}
            />
            <p className="phoneError">{this.state.phoneError}</p>
            </td>
          </tr>
          </tbody>
        </table>
        
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  requestCurrentUserNotifications: () => dispatch(actionCreators.requestCurrentUserNotifications()),
  editCurrentUserNotifications: (currentUser) => dispatch(actionCreators.editCurrentUserNotifications(currentUser))
});

function mapStateToProps(state) {
  return {
      currentUser: state.users.currentUser
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);


const NotificationSwitch = withStyles({
  switchBase: {
    color: "#767C83",
    '&$checked': {
      color: "#97C221",
    },
    '&$checked + $track': {
      backgroundColor: "#97C221",
    },
  },
  checked: {},
  track: {},
})(Switch);


// WEBPACK FOOTER //
// ./src/components/Settings.js